import React from 'react';
import {MTableEditField} from 'material-table';

export default function NullableTableEditField({value, ...props}) {
    if(value === null) {
        value = undefined;
    }
    return <MTableEditField value={value} {...props}/>;
}